import React, {useState} from "react";
import SignUpForm from "../components/auth/SignUpForm";

const SignUp = () => {

    return (
        <SignUpForm 
            
        />
    );
};

export default SignUp;